@file:OptIn(ExperimentalBlockRichTextApi::class)

package com.taocent.simple.compose.component.blockrichtext.internal.block.renderer

import androidx.compose.foundation.Image
import androidx.compose.foundation.gestures.detectTapGestures
import androidx.compose.foundation.layout.Box
import androidx.compose.material3.DropdownMenu
import androidx.compose.material3.DropdownMenuItem
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.input.pointer.pointerInput
import com.composables.icons.feather.Feather
import com.composables.icons.feather.MoreHorizontal
import com.composables.icons.feather.MoreVertical
import com.taocent.simple.compose.component.blockrichtext.ExperimentalBlockRichTextApi

/**
 * 表格菜单组件集合:`ThreeDotsButton`(行/列按钮上的三点图标),
 * `ColumnMenu`(列菜单),`RowMenu`(行菜单)。
 *
 * 这些组件被 `TableRowButton` / `TableColumnButton` 共享,单独抽出避免在
 * 那个长文件里重复声明,也便于阅读。
 */

@Composable
internal fun ThreeDotsButton(
    horizontal: Boolean,
    modifier: Modifier = Modifier,
    onClick: () -> Unit
) {
    Box(
        modifier = modifier
            .pointerInput(Unit) {
                detectTapGestures(onTap = { onClick() })
            },
        contentAlignment = Alignment.Center
    ) {
        Image(
            imageVector = if (horizontal) Feather.MoreHorizontal else Feather.MoreVertical,
            contentDescription = null
        )
    }
}

@Composable
internal fun ColumnMenu(
    expanded: Boolean,
    onDismiss: () -> Unit,
    onInsertLeft: () -> Unit,
    onInsertRight: () -> Unit,
    onDelete: () -> Unit
) {
    DropdownMenu(
        expanded = expanded,
        onDismissRequest = onDismiss
    ) {
        DropdownMenuItem(
            text = { Text("在左侧插入列") },
            onClick = onInsertLeft
        )
        DropdownMenuItem(
            text = { Text("在右侧插入列") },
            onClick = onInsertRight
        )
        DropdownMenuItem(
            text = { Text("删除当前列") },
            onClick = onDelete
        )
    }
}

@Composable
internal fun RowMenu(
    expanded: Boolean,
    onDismiss: () -> Unit,
    onInsertAbove: () -> Unit,
    onInsertBelow: () -> Unit,
    onInsertTableAbove: () -> Unit,
    onDelete: () -> Unit,
    onDeleteTable: () -> Unit
) {
    DropdownMenu(
        expanded = expanded,
        onDismissRequest = onDismiss
    ) {
        DropdownMenuItem(
            text = { Text("在上方插入行") },
            onClick = onInsertAbove
        )
        DropdownMenuItem(
            text = { Text("在下方插入行") },
            onClick = onInsertBelow
        )
        DropdownMenuItem(
            text = { Text("在上方插入表格") },
            onClick = onInsertTableAbove
        )
        DropdownMenuItem(
            text = { Text("删除当前行") },
            onClick = onDelete
        )
        DropdownMenuItem(
            text = { Text("删除当前表格") },
            onClick = onDeleteTable
        )
    }
}
